import { listShareableAccounts } from '../thunks/shareable-accounts';
import { handlePending, handleRejected } from './utils';

export const shareableAccountsReducers = (builder) => {
  // List shareable accounts
  builder
    .addCase(listShareableAccounts.fulfilled, (state, action) => {
      const accounts = action.payload || [];
      state.shareableAccounts.value = accounts;
      state.shareableAccounts.loading = false;
    })
    .addCase(listShareableAccounts.pending, (state) => handlePending(state, 'shareableAccounts'))
    .addCase(listShareableAccounts.rejected, (state) => handleRejected(state, 'shareableAccounts'));
};
